import React from 'react'
import tinycolor from 'tinycolor2'
import { ColorScheme } from '@app-types/general'
import { DARK_TEXT_COLOR, LIGHT_TEXT_COLOR } from '@constants/hardcoded_color_schemes'

// Helper to generate soft, strong, and contrast colors
const getColorVariants = (color: string) => {
  const tinyColorInstance = tinycolor(color)
  const isLight = tinyColorInstance.isLight()
  return {
    base: tinyColorInstance.toHexString(),
    soft: isLight ? tinyColorInstance.darken(7).toHexString() : tinyColorInstance.lighten(7).toHexString(),
    strong: isLight ? tinyColorInstance.darken(15).toHexString() : tinyColorInstance.lighten(15).toHexString(),
    contrast: isLight ? DARK_TEXT_COLOR : LIGHT_TEXT_COLOR,
  }
}

// Converts a theme object (like one provided to the component by a provider component) into a
// style object.
export const convertViewThemeToCSSProperties = (theme: ColorScheme): React.CSSProperties => {
  const primary = getColorVariants(theme.primary)
  const secondary = getColorVariants(theme.secondary)
  const tertiary = getColorVariants(theme.tertiary)
  const highlight = getColorVariants(theme.highlight)

  return {
    '--view-theme-primary': primary.base,
    '--view-theme-primary-soft': primary.soft,
    '--view-theme-primary-strong': primary.strong,
    '--view-theme-primary-contrast': primary.contrast,
    '--view-theme-secondary': secondary.base,
    '--view-theme-secondary-soft': secondary.soft,
    '--view-theme-secondary-strong': secondary.strong,
    '--view-theme-secondary-contrast': secondary.contrast,
    '--view-theme-tertiary': tertiary.base,
    '--view-theme-tertiary-soft': tertiary.soft,
    '--view-theme-tertiary-strong': tertiary.strong,
    '--view-theme-tertiary-contrast': tertiary.contrast,
    '--view-theme-highlight': highlight.base,
    '--view-theme-highlight-soft': highlight.soft,
    '--view-theme-highlight-strong': highlight.strong,
    '--view-theme-highlight-contrast': highlight.contrast,
  } as React.CSSProperties
}
